module.exports = __webpack_public_path__ + "img/cassette.232421ec.jpg";